import React from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { configs } from '../members/utils';
import { StyledParagraph } from './ResetPasswordStyles';
import Header from './Header';

const ResetPasswordSuccess = () => {
    const intl = useIntl();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hhid = searchParams.get('hhid');
    const email = location.state?.email;
    const url = `${configs.routes.RESET_PASSWORD}?hhid=${hhid}`;

    if (!email) navigate(url, { replace: true });

    return (
        <>
            <Header title={intl.formatMessage({ id: 'resetPassword.success.title' })} />
            <StyledParagraph>
                <FormattedMessage
                    id={'resetPassword.success.message'}
                    tagName={'span'}
                    values={{
                        email: <strong>{email}</strong>,
                    }}
                />
            </StyledParagraph>
            <StyledParagraph>{intl.formatMessage({ id: 'resetPassword.success.message2' })}</StyledParagraph>
        </>
    );
};

export default ResetPasswordSuccess;
